import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-send-icon]',
  template: `
    <svg:path
      d="M2.58692 3.18021L4.43238 7.33251H7.99914C8.36733 7.33251 8.6658 7.63098 8.6658 7.99917C8.6658 8.36736 8.36733 8.66584 7.99914 8.66584H4.43238L2.58692 12.8181C7.36368 10.9822 11.3947 8.96822 13.2507 7.99917C11.3947 7.03012 7.36368 5.01611 2.58692 3.18021ZM3.26959 7.99917L1.04177 2.98659C0.684495 2.18271 1.4682 1.33438 2.30204 1.64623C8.07125 3.80385 12.8965 6.29542 14.4556 7.12737C15.1568 7.50149 15.1568 8.49685 14.4556 8.87098C12.8965 9.70292 8.07125 12.1945 2.30204 14.3521C1.4682 14.664 0.684493 13.8156 1.04177 13.0118L3.26959 7.99917Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
